/* Auto-advance + loop for product-grid sliders. Pauses on hover & touch. */
(function () {
  function init() {
    const sliderComponents = document.querySelectorAll('slider-component');
    sliderComponents.forEach(function (component) {
      const slider = component.querySelector('.product-grid.slider');
      const next = component.querySelector('.slider-button--next');
      if (!slider || !next) return;
      if (component.dataset.autoAdvanceInit === '1') return;
      component.dataset.autoAdvanceInit = '1';

      let isPaused = false;
      let timer = null;

      function advance() {
        if (isPaused) return;
        const maxScroll = slider.scrollWidth - slider.clientWidth;
        if (slider.scrollLeft >= maxScroll - 10) {
          slider.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          next.click();
        }
      }

      function start() {
        stop();
        timer = setInterval(advance, 5000);
      }

      function stop() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      component.addEventListener('mouseenter', function () { isPaused = true; });
      component.addEventListener('mouseleave', function () { isPaused = false; });
      component.addEventListener('touchstart', function () { isPaused = true; }, { passive: true });
      component.addEventListener('touchend', function () { isPaused = false; }, { passive: true });
      component.addEventListener('focusin', function () { isPaused = true; });
      component.addEventListener('focusout', function () { isPaused = false; });

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      start();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
